"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivitiesDB = getActivitiesDB;
const orama_1 = require("@orama/orama");
async function getActivitiesDB(activities, options = {}) {
    const { queryFields = ['assay'] } = options;
    const activitiesDB = await (0, orama_1.create)({
        schema: {
            $id: 'string',
            ...(queryFields.includes('assay') ? { assay: 'string' } : null),
        },
    });
    for (const activity of activities) {
        let assay = {
            $id: activity.$id,
        };
        assay.assay = activity.data.assay;
        await (0, orama_1.insert)(activitiesDB, assay);
    }
    return activitiesDB;
}
//# sourceMappingURL=getActivitiesDB.js.map